<template>
  <table class="table tablesorter" :class="tableClass">
    <thead :class="theadClasses">
      <tr>
        <slot name="columns" :columns="columns">
          <th v-for="column in columns" :key="column[0]">
            <a href="#" v-on:click.prevent="sortBy(column[0])" v-bind:class="{'active-sort':(sortKey==column[0] && !reverse), 'active-sort-reverse':(sortKey==column[0] && reverse)}" >{{ column[1] }}</a>
          </th>
        </slot>
      </tr>
    </thead>
    <tbody :class="tbodyClasses">
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item" :index="index">
          <td
            v-for="(column, index) in colsWithValue(item)"
            :key="index">
            {{ itemValue(item, column) }}
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'base-table',
  props: {
    columns: {
      type: Array,
      default: () => [],
      description: 'Table columns'
    },
    data: {
      type: Array,
      default: () => [],
      description: 'Table data'
    },
    type: {
      type: String, // striped | hover
      default: '',
      description: 'Whether table is striped or hover type'
    },
    theadClasses: {
      type: String,
      default: '',
      description: '<thead> css classes'
    },
    tbodyClasses: {
      type: String,
      default: '',
      description: '<tbody> css classes'
    },
    reverse: {
      type: Boolean,
      default: true,
      description: 'Way of ordering object'
    },
    sortKey: {
      type: String,
      default: '',
      description: 'Key for ordering object'
    }
  },
  computed: {
    tableClass() {
      return this.type && `table-${this.type}`;
    },
    colsWithValue() {
      return (row) => {
        return this.columns.filter(column => this.hasValue(row, column))
      }
    },
  },
  methods: {
    hasValue(item, column) {
      return item[column[0].toLowerCase()] !== 'undefined';
    },
    itemValue(item, column) {
      return item[column[0].toLowerCase()];
    },
    sortBy: function(sortKey) {
      this.$emit('sortKey', sortKey)
      this.$emit('reverse', (this.sortKey == sortKey) ? ! this.reverse : false)
      this.$emit('KeyChanged', sortKey)
      
    },
  }
};
</script>
<style>
.active-sort, .active-sort-reverse { 
  color:black;
  text-decoration: underline;
}
.active-sort:after {
  font-family: "NucleoIcons";
  content: "\EA12";
  margin-top:4px;
}
.active-sort-reverse:after {
  font-family: "NucleoIcons";
  content: "\EA0F";
  margin-top:4px;
}
</style>
